<!-- WRAP IF DISPLAY AS TEXT -->
<ng-container [ngSwitch]="displayType">
  <div *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TEXT" [ngClass]="{'lm-is-single-line': isSingleLine, 'lm-parent-is-number-label': isNumberLabel}">
    <ng-container *ngTemplateOutlet="richtextComponentTemplate"></ng-container>
  </div>
  <ng-container *ngSwitchCase="layoutDisplayType.PLAIN">
    <div *ngIf="isNumberLabel" class="lm-parent-is-number-label">
      <ng-container *ngTemplateOutlet="richtextComponentTemplate"></ng-container>
    </div>
    <ng-container *ngIf="!isNumberLabel">
      <ng-container *ngTemplateOutlet="richtextComponentTemplate"></ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #richtextComponentTemplate>
  <label
    *ngIf="label"
    [attr.for]="id"
    soho-label
      [required]="isRequired"
    lm-label
      [layoutField]="field"
      [parentIsFormLayout]="parentIsFormLayout"
      [personalize]="personalize"
    lm-text-style
      [textStyle]="field?.label?.textStyle"
  >{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
  <div
      lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      lm-layout-util
        [hideWhiteSpace]="!(lmColumnLayoutInfo && lmColumnLayoutInfo.nbrColumns > 1)"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'bottom'"
        [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)">
      <!--LMCLIENT-33701: adding hidden span because it is not valid to associate label with div which is not a labelable element.-->
      <span 
        *ngIf="!displayAsText"
        id="{{id}}_label"
        class="label hidden"
      >{{(triggerValue | formatLabelRule:field:labelResourceValue:model:specFields) || bindId}}</span>
    <ng-container [ngSwitch]="displayType">
      <div [ngClass]="{'field' : true, 'field-options-width-override': !displayAsText, 'lm-richtext-block' : !displayAsText}">
        <div *ngSwitchCase="layoutDisplayType.PLAIN"
             #Input
             [ngClass]="fieldClassesString"
             [attr.name]="id"
             [attr.id]="id"
             [attr.bindId]="bindId"
             class="lm-richtext-content"
             [attr.tabindex]="isInAccessibilityMode ? 0 : isReadOnly ? -1 : null"
             soho-editor
             [rows]="rows"
             soho-alert
             soho-trackdirty
             (dirty)="onDirty($event)"
             (pristine)="onPristine($event)"
             (afterResetDirty)="onAfterResetDirty($event)"
             soho-input-validate
             (error)="onError($event)"
             (valid)="onValid($event)"
             (blur)="onBlur($event)"
             (change)="onRichTextChange()"
        ></div>
        <!-- See also lm-text.component.html for form text with hasRichTextVars -->
        <div *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TEXT"
             [ngClass]="fieldClassesString"
             class="lm-richtext-content is-preview hide-white-space"
             [attr.name]="id"
             [attr.id]="id"
             [attr.bindId]="bindId"
             [attr.tabindex]="isInAccessibilityMode ? 0 : null"
             [innerHTML]="triggerValue | richText:richTextValue"
             soho-editor
             [preview]="true"
             soho-alert></div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
